@if (isDisplayed()) {
  <a
    class="banner-content text-grey-90 is-flex gap-8 sm:gap-16 bg-grey-0 radius-12 is-align-stretch"
    [attr.href]="bannerLink"
  >
    <div class="is-flex-shrink-0 is-flex is-align-center">
      <img
        class=""
        srcset="/assets/banner/banner.jpg, /assets/banner/banner@2x.jpg 2x, /assets/banner/banner@3x.jpg 3x"
        alt=""
      />
    </div>
    <div class="text-content is-flex is-column is-justify-space-between is-flex-grow-1">
      <div class="is-flex is-justify-space-between">
        <app-text class="is-family-semiBold text-14 sm:text-16" [text]="'Black Friday'" />
        <app-icon class="text-blue text-32" name="small-arrow-right" />
      </div>
      <app-text
        class="is-family-medium text-12 sm:text-14 text-grey-70"
        [text]="'app.__NFA_BLACK_FRIDAY_PROMO' | AsyncLang | async"
      />
    </div>
  </a>
}
